const PatientGroupStore = {
	data: {
		groups: [
			{
				id: '700001',
				name: 'Arbutus',
				patients: [1,2,3,4,5,6,7,8],
				filterStatus: true,
			},
		]
	},
	methods: {
		getGroupObject($id) {
			let $index = PatientGroupStore.data.groups.findIndex(
				element => element.id == $id
			);
			return PatientGroupStore.data.groups[$index];
		},
		setStatus($id, $status) {
			let $index = PatientGroupStore.data.groups.findIndex(
				element => element.id == $id
			);
			PatientGroupStore.data.groups[$index].filterStatus = $status;
		},
	}
};

export default PatientGroupStore;